(() => {
  'use strict';
  const dialog = document.getElementById('ProductWaitlist');
  if (!dialog || dialog.dataset.bound) return;
  dialog.dataset.bound = 'true';
  const form = dialog.querySelector('[data-waitlist-form]');
  const entry = dialog.querySelector('[data-waitlist-entry]');
  const success = dialog.querySelector('[data-waitlist-success]');
  const error = dialog.querySelector('[data-waitlist-error]');
  const submit = form.querySelector('[type=submit]');
  const submitLabel = submit.textContent;
  let opener, product, pending = false, previousOverflow;
  const fit = () => {
    const viewport = window.visualViewport;
    dialog.style.setProperty('--wl-viewport', `${viewport?.height || window.innerHeight}px`);
    // Center inside the visible area, including when the phone keyboard opens.
    if (dialog.open) {
      dialog.style.top = `${viewport?.offsetTop || 0}px`;
      dialog.style.bottom = 'auto';
      dialog.style.marginTop = `${Math.max(12, ((viewport?.height || innerHeight) - dialog.offsetHeight) / 2)}px`;
    }
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-waitlist-open]');
    if (!trigger) return;
    event.preventDefault();
    if (pending) return;
    opener = trigger;
    product = {
      productId: trigger.dataset.productId,
      handle: trigger.dataset.productHandle,
      variantId: document.getElementById(trigger.dataset.variantForm)?.querySelector('[data-variant-id]')?.value || trigger.dataset.variant,
    };
    dialog.querySelector('[data-waitlist-piece]').textContent = trigger.dataset.productTitle;
    form.reset(); entry.hidden = false; success.hidden = true; error.hidden = true;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
    dialog.querySelector('h2').focus({ preventScroll: true }); // Keep the phone keyboard closed until requested.
    fit();
  });
  dialog.querySelectorAll('[data-waitlist-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    opener?.focus({ preventScroll: true });
  });
  window.visualViewport?.addEventListener('resize', fit);
  window.visualViewport?.addEventListener('scroll', fit);
  window.addEventListener('resize', fit);
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (pending || !form.reportValidity()) return;
    error.hidden = true;
    if (!dialog.dataset.endpoint) { error.textContent = dialog.dataset.unavailable; error.hidden = false; fit(); return; }
    pending = true; submit.disabled = true; submit.textContent = dialog.dataset.submitting;
    form.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(dialog.dataset.endpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit',
        body: JSON.stringify({ ...product, email: form.elements.email.value.trim(), website: form.elements.website.value, consent: 'availability-v1', locale: document.documentElement.lang || 'en' }),
        signal: AbortSignal.timeout(15000),
      });
      const result = await response.json();
      if (!response.ok || result.ok !== true) throw new Error('Waitlist not saved');
      form.reset(); entry.hidden = true; success.hidden = false;
      if (dialog.open) { success.focus({ preventScroll: true }); fit(); }
    } catch {
      error.textContent = dialog.dataset.error; error.hidden = false; fit();
    } finally {
      pending = false; submit.disabled = false; submit.textContent = submitLabel; form.removeAttribute('aria-busy');
    }
  });
})();
